// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table_AwLK9 {
  position : absolute !important;
  top : 0;
  left : 0;
  right : 0;
  bottom : 0;
}

.table_AwLK9 .rt-td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.table_AwLK9 .rt-tr-group {
  flex : none !important;
}

.padding_Z5e_A {
  padding : 10px 20px;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-user-management/lib/ResourceUsersScreen.css"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["\n.table {\n  position : absolute !important;\n  top : 0;\n  left : 0;\n  right : 0;\n  bottom : 0;\n}\n\n.table :global( .rt-td ) {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.table :global( .rt-tr-group ) {\n  flex : none !important;\n}\n\n.padding {\n  padding : 10px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_AwLK9`,
	"padding": `padding_Z5e_A`
};
export default ___CSS_LOADER_EXPORT___;
